<div class="p-24">
    <div class="row">
        <div class="col-lg-8">
            <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.MEDICLAIM' | translate }}</h3>
            <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.MEDICLAIM' | translate }} </h3>
        </div>
        <div class="col-lg-4">
        </div>
    </div>

    <form [formGroup]="mediclaimForm">
        <div class="row m-t-20">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.MEDICLAIM_LABEL' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.MEDICLAIM_LABEL' | translate }}" formControlName="name">
                    <mat-error *ngIf="mediclaimForm.get('name')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="mediclaimForm.get('name')?.hasError('minlength')">
                        {{ 'REQUIRED.CHARACTERS' | translate }}
                    </mat-error>

                </mat-form-field>

            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.WEBURL_LABEL' | translate }}</mat-label>
                    <input type="url" matInput placeholder="{{ 'LABEL.MEDICLAIM_LABEL' | translate }}" formControlName="weburl">
                    <mat-error *ngIf="mediclaimForm.get('weburl')?.hasError('pattern')">
                        {{ 'REQUIRED.URL' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <mat-checkbox color="primary" formControlName="isDefault">
                    <mat-label class="f-s-15 f-w-600 m-b-10">{{ 'LABEL.ISDEFAULT_LABEL' | translate }}&nbsp;</mat-label>
                </mat-checkbox>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8"></div>
            <div class="col-lg-4 d-flex justify-content-end">
                <button mat-stroked-button (click)="OnCloseDialog()" class="m-l-4 m-r-5">{{ 'BUTTON.BTN_CLOSE' | translate }}</button>
                <button mat-flat-button color="primary" class="m-r-5 m-l-4" (click)="onUpdateMediclaim()" *ngIf="isEdit"
                    [disabled]="mediclaimForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

                <button mat-flat-button color="primary" class="m-l-4" (click)="onSaveMediclaim()" *ngIf="!isEdit"
                    [disabled]="mediclaimForm.invalid">
                    {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            </div>
        </div>
    </form>
</div>